import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class Diamond extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M15.0625 6.47656L8 15.1719L0.9375 6.47656L5.13281 2H10.8672L15.0625 6.47656ZM9.85938 6L8.73438 3H7.26562L6.14062 6H9.85938ZM6.08594 7L8 13.7031L9.91406 7H6.08594ZM5.35938 3L2.55469 6H5.23438L6.35938 3H5.35938ZM2.45312 7L6.6875 12.2109L5.19531 7H2.45312ZM9.3125 12.2109L13.5469 7H10.8047L9.3125 12.2109ZM13.4453 6L10.6406 3H9.64062L10.7656 6H13.4453Z" })));
    }
}
